var scope_0 = require('C:/Users/nlnt/repos/netcompany/java-oop-presentation/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3e3e19312b0c11d5dc3f6cbe03056b63.js').default;export default
        Object.assign({}, scope_0 )
    